// MB.1 — doors. PURE (ENG-1). The engine keeps doors simple (facing + open, two
// cells tall); this module holds the species-agnostic predicates plus the
// double-door rule: opening one leaf of a side-by-side pair swings its partner
// too. The host walks these offsets and flips the shared open state.

/** Any wood-species door block (`oak_door`, `spruce_door`, …). */
export function isDoor(name: string | undefined): name is string {
  return !!name && name.endsWith('_door');
}

/**
 * The two horizontal neighbour cells (dx,dz) that could hold a door's
 * double-door partner: the cells to either side along the axis perpendicular to
 * `facing` (a door's width runs across its facing). A partner is a same-name,
 * same-facing door, and it swings to match.
 */
export function partnerOffsets(facing: string): readonly [number, number][] {
  // north/south-facing doors sit in a row along X; east/west along Z.
  return facing === 'north' || facing === 'south'
    ? [[-1, 0], [1, 0]]
    : [[0, -1], [0, 1]];
}

/** The vertical cells of a two-tall door, relative to a clicked cell. */
export const DOOR_HALVES: readonly number[] = [0, 1, -1];

/** Toggle helper: the open value a closed/open door should take next. */
export function nextOpen(open: string | undefined): 'true' | 'false' {
  return open === 'true' ? 'false' : 'true';
}
